import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * スイッチオフアイコン
 */
const RadioOffIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="51"
        height="31"
        viewBox="0 0 51 31"
      >
        <g transform="translate(-0.5 0)">
          <path
            d="M15.857.092C17.6-.008,19.335,0,21.075,0h8.817c1.774,0,3.512-.008,5.251.092A21.645,21.645,0,0,1,39.8.8a15.242,15.242,0,0,1,0,29.394,21.707,21.707,0,0,1-4.654.711c-1.739.1-3.477.091-5.217.091H21.107c-1.772,0-3.51.008-5.25-.092A21.708,21.708,0,0,1,11.2,30.2,15.242,15.242,0,0,1,11.2.8,21.645,21.645,0,0,1,15.857.092Z"
            transform="translate(0.5)"
            fill={CLIENT_SETTINGS.colors.background}
          />
          <g
            transform="translate(2 1.5)"
            fill={CLIENT_SETTINGS.colors.textForMainBackground}
            stroke="rgba(0,0,0,0.04)"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          >
            <rect width="28" height="28" rx="14" stroke="none" />
            <rect
              x="-0.25"
              y="-0.25"
              width="28.5"
              height="28.5"
              rx="14.25"
              fill="none"
            />
          </g>
        </g>
      </svg>
    </Icon>
  )
}

export default RadioOffIcon
